import React from 'react';
import { Eyebrow, Section } from './Section';
const markers = ['Un nombre de séances limité', 'Un accompagnement orienté vers l’autonomie', 'Un contrat écrit', 'Un code de déontologie'];
export function Credibility() {
  return <Section tone="creme" labelledBy="credibilite-title" data-id="element-76" data-mp="2zf1g6gmwi5d5">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-77" data-mp="2umqfvco90hk2">
        <div className="lg:col-span-6" data-id="element-78" data-mp="2ul5k5jq76skm">
          <Eyebrow data-id="element-79" data-mp="38dlqateeb6pr">Repères du métier</Eyebrow>
          <h2 id="credibilite-title" className="font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.5rem]" data-id="element-80" data-mp="38ghqkodpu7hd">
            Ce que l’on attend aujourd’hui d’un coach sérieux
          </h2>
          <p className="mt-8 max-w-prose text-base leading-relaxed text-graphite-mid md:text-lg" data-id="element-81" data-mp="3dcybzatj67qr">
            Les guides destinés aux personnes qui cherchent un coach
            recommandent tous la même chose. Le Système Complet du Coach est
            construit exactement sur ces quatre repères.
          </p>
        </div>

        <ol className="divide-y divide-warm-line border-y border-warm-line lg:col-span-6" data-id="element-82" data-mp="31h8jelci5hve">
          {markers.map((marker, index) => <li key={marker} className="flex items-baseline gap-5 py-5" data-id="element-83" data-mp="35f69dqe3k7zu" data-mpi={index}>
              <span className="font-serif text-sm text-warm-light" data-id="element-84" data-mp="3afanj9rj8qmw">
                0{index + 1}
              </span>
              <p className="text-base leading-relaxed text-graphite" data-id="element-85" data-mp="3f96jy7s5e5fy">
                {marker}
              </p>
            </li>)}
        </ol>
      </div>
    </Section>;
}